{
  "en": {
    "iaTasks": {
      "documentLabel": "Document {index}",
      "retryError": "Failed to retry the task. Please try again.",
      "contributorRecovery": {
        "title": "Contributor recovery",
        "status": {
          "inProgress": "Contributor recovery in progress",
          "partial": "Contributor recovery partially completed",
          "success": "Contributor recovery completed successfully",
          "error": "Contributor recovery failed",
          "timeout": "Contributor recovery is taking longer than expected"
        }
      },
      "documentClassification": {
        "title": "Document classification",
        "status": {
          "inProgress": "AI document classification in progress, please wait",
          "partial": "Document classification partially completed",
          "success": "Document classification completed successfully",
          "error": "Document classification failed, please retry using the retry button",
          "timeout": "Document classification is taking longer than expected"
        },
        "completion": {
          "message": "AI document classification completed. AI can make mistakes.",
          "link": "Check the result"
        }
      },
      "pvAnalysis": {
        "title": "PV analysis",
        "status": {
          "inProgress": "PV analysis in progress",
          "partial": "PV analysis partially completed",
          "success": "PV analysis completed successfully",
          "error": "PV analysis failed",
          "timeout": "PV analysis is taking longer than expected"
        }
      },
      "workDescription": {
        "title": "Work description",
        "status": {
          "inProgress": "Work description analysis in progress",
          "partial": "Work description analysis partially completed",
          "success": "Work description analysis completed successfully",
          "error": "Work description analysis failed",
          "timeout": "Work description analysis is taking longer than expected"
        }
      },
      "pcAtRecovery": {
        "title": "PC / AT recovery",
        "status": {
          "inProgress": "PC / AT recovery in progress",
          "partial": "PC / AT recovery partially completed",
          "success": "PC / AT recovery completed successfully",
          "error": "PC / AT recovery failed",
          "timeout": "PC / AT recovery is taking longer than expected"
        }
      },
      "safetyReviewRecovery": {
        "title": "Safety commission review",
        "status": {
          "inProgress": "Safety commission review analysis in progress",
          "partial": "Safety commission review analysis partially completed",
          "success": "Safety commission review analysis completed successfully",
          "error": "Safety commission review analysis failed",
          "timeout": "Safety commission review analysis is taking longer than expected"
        }
      },
      "staffingRecovery": {
        "title": "Staffing table",
        "status": {
          "inProgress": "Staffing table analysis in progress",
          "partial": "Staffing table analysis partially completed",
          "success": "Staffing table analysis completed successfully",
          "error": "Staffing table analysis failed",
          "timeout": "Staffing table analysis is taking longer than expected"
        }
      },
      "clearanceRecovery": {
        "title": "Clearance table",
        "status": {
          "inProgress": "Clearance table analysis in progress",
          "partial": "Clearance table analysis partially completed",
          "success": "Clearance table analysis completed successfully",
          "error": "Clearance table analysis failed",
          "timeout": "Clearance table analysis is taking longer than expected"
        }
      }
    }
  },
  "fr": {
    "iaTasks": {
      "documentLabel": "Document {index}",
      "retryError": "Échec de la relance de la tâche. Veuillez réessayer.",
      "contributorRecovery": {
        "title": "Récupération des intervenants",
        "status": {
          "inProgress": "Récupération des intervenants en cours",
          "partial": "Récupération des intervenants partiellement terminée",
          "success": "Récupération des intervenants terminée avec succès",
          "error": "Récupération des intervenants en erreur",
          "timeout": "La récupération des intervenants prend plus de temps que prévu"
        }
      },
      "documentClassification": {
        "title": "Classification Document",
        "status": {
          "inProgress": "Classification Document(s) par IA en cours, veuillez patienter",
          "partial": "Classification document partiellement terminée",
          "success": "Classification document terminée avec succès",
          "error": "Erreur lors de la Classification Document(s), veuillez réessayer en cliquant sur \"Relancer l'analyse\"",
          "timeout": "La classification document prend plus de temps que prévu"
        },
        "completion": {
          "message": "Classification Document(s) par IA terminée. L'IA peut faire des erreurs.",
          "link": "Vérifier le résultat"
        }
      },
      "pvAnalysis": {
        "title": "Analyse PV",
        "status": {
          "inProgress": "Analyse PV en cours",
          "partial": "Analyse PV partiellement terminée",
          "success": "Analyse PV terminée avec succès",
          "error": "Analyse PV en échec",
          "timeout": "L'analyse PV prend plus de temps que prévu"
        }
      },
      "workDescription": {
        "title": "Description de l'ouvrage",
        "status": {
          "inProgress": "Description de l'ouvrage en cours",
          "partial": "Description de l'ouvrage partiellement terminée",
          "success": "Description de l'ouvrage terminée avec succès",
          "error": "Description de l'ouvrage en échec",
          "timeout": "La description de l'ouvrage prend plus de temps que prévu"
        }
      },
      "pcAtRecovery": {
        "title": "Récupération PC / AT",
        "status": {
          "inProgress": "Récupération PC / AT en cours",
          "partial": "Récupération PC / AT partiellement terminée",
          "success": "Récupération PC / AT terminée avec succès",
          "error": "Récupération PC / AT en échec",
          "timeout": "La récupération PC / AT prend plus de temps que prévu"
        }
      },
      "safetyReviewRecovery": {
        "title": "Avis Commission de Sécurité",
        "status": {
          "inProgress": "Analyse des avis de commission de sécurité en cours",
          "partial": "Analyse des avis de commission de sécurité partiellement terminée",
          "success": "Analyse des avis de commission de sécurité terminée avec succès",
          "error": "Analyse des avis de commission de sécurité en échec",
          "timeout": "L'analyse des avis de commission de sécurité prend plus de temps que prévu"
        }
      },
      "staffingRecovery": {
        "title": "Tableau des effectifs",
        "status": {
          "inProgress": "Analyse du tableau des effectifs en cours",
          "partial": "Analyse du tableau des effectifs partiellement terminée",
          "success": "Analyse du tableau des effectifs terminée avec succès",
          "error": "L'analyse du tableau des effectifs a échoué",
          "timeout": "L'analyse du tableau des effectifs prend plus de temps que prévu"
        }
      },
      "clearanceRecovery": {
        "title": "Tableau des dégagements",
        "status": {
          "inProgress": "Analyse du tableau des dégagements en cours",
          "partial": "Analyse du tableau des dégagements partiellement terminée",
          "success": "Analyse du tableau des dégagements terminée avec succès",
          "error": "L'analyse du tableau des dégagements a échoué",
          "timeout": "L'analyse du tableau des dégagements prend plus de temps que prévu"
        }
      }
    }
  },
  "nl": {
    "iaTasks": {
      "documentLabel": "Document {index}",
      "retryError": "Opnieuw proberen mislukt. Probeer het opnieuw.",
      "contributorRecovery": {
        "title": "Medewerkers ophalen",
        "status": {
          "inProgress": "Medewerkers ophalen bezig",
          "partial": "Medewerkers ophalen gedeeltelijk voltooid",
          "success": "Medewerkers ophalen succesvol voltooid",
          "error": "Medewerkers ophalen mislukt",
          "timeout": "Het ophalen van medewerkers duurt langer dan verwacht"
        }
      },
      "documentClassification": {
        "title": "Documentclassificatie",
        "status": {
          "inProgress": "AI-documentclassificatie bezig, even geduld",
          "partial": "Documentclassificatie gedeeltelijk voltooid",
          "success": "Documentclassificatie succesvol voltooid",
          "error": "Documentclassificatie mislukt, probeer het opnieuw via de knop opnieuw proberen",
          "timeout": "Documentclassificatie duurt langer dan verwacht"
        },
        "completion": {
          "message": "AI-documentclassificatie voltooid. AI kan fouten maken.",
          "link": "Resultaat bekijken"
        }
      },
      "pvAnalysis": {
        "title": "PV-analyse",
        "status": {
          "inProgress": "PV-analyse bezig",
          "partial": "PV-analyse gedeeltelijk voltooid",
          "success": "PV-analyse succesvol voltooid",
          "error": "PV-analyse mislukt",
          "timeout": "PV-analyse duurt langer dan verwacht"
        }
      },
      "workDescription": {
        "title": "Werkomschrijving",
        "status": {
          "inProgress": "Werkomschrijving bezig",
          "partial": "Werkomschrijving gedeeltelijk voltooid",
          "success": "Werkomschrijving succesvol voltooid",
          "error": "Werkomschrijving mislukt",
          "timeout": "Werkomschrijving duurt langer dan verwacht"
        }
      },
      "pcAtRecovery": {
        "title": "PC / AT-herstel",
        "status": {
          "inProgress": "PC / AT-herstel bezig",
          "partial": "PC / AT-herstel gedeeltelijk voltooid",
          "success": "PC / AT-herstel succesvol voltooid",
          "error": "PC / AT-herstel mislukt",
          "timeout": "PC / AT-herstel duurt langer dan verwacht"
        }
      },
      "safetyReviewRecovery": {
        "title": "Advies van de veiligheidscommissie",
        "status": {
          "inProgress": "Analyse van de adviezen van de veiligheidscommissie bezig",
          "partial": "Analyse van de adviezen van de veiligheidscommissie gedeeltelijk voltooid",
          "success": "Analyse van de adviezen van de veiligheidscommissie succesvol voltooid",
          "error": "Analyse van de adviezen van de veiligheidscommissie mislukt",
          "timeout": "Analyse van de adviezen van de veiligheidscommissie duurt langer dan verwacht"
        }
      },
      "staffingRecovery": {
        "title": "Bezettingstabel",
        "status": {
          "inProgress": "Analyse van de bezettingstabel wordt uitgevoerd",
          "partial": "Analyse van de bezettingstabel gedeeltelijk voltooid",
          "success": "Analyse van de bezettingstabel succesvol voltooid",
          "error": "Analyse van de bezettingstabel mislukt",
          "timeout": "Analyse van de bezettingstabel duurt langer dan verwacht"
        }
      },
      "clearanceRecovery": {
        "title": "Uitgangentabel",
        "status": {
          "inProgress": "Analyse van de uitgangentabel wordt uitgevoerd",
          "partial": "Analyse van de uitgangentabel gedeeltelijk voltooid",
          "success": "Analyse van de uitgangentabel succesvol voltooid",
          "error": "Analyse van de uitgangentabel mislukt",
          "timeout": "Analyse van de uitgangentabel duurt langer dan verwacht"
        }
      }
    }
  }
}
